import React from 'react';
import styled from 'styled-components';

import FullWidthMainContentZone from '../FullWidthMainContentZone';
import MainContent from '../MainContent';

export const StyledContainer = styled(FullWidthMainContentZone)<{
  bottomBorder?: string;
}>`
  border-bottom: ${({ bottomBorder, theme }) => bottomBorder || `1px solid ${theme.colors.gray3}`};
`;

export const StyledContent = styled((props) => <MainContent {...props} as="section" />)``;
